<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useVuelidate } from '@vuelidate/core'
import { useUmsokn } from '@/composables/Applications/UseUmsokn'

const { t } = useI18n()
const { umsokn } = useUmsokn()

const props = defineProps<{
  disable?: boolean
}>()

// no rules for now (textarea is optional)
const rules = { umsokn: {} }
const v$ = useVuelidate(rules, { umsokn })

defineExpose({
  validate() {
    v$.value.$touch()
    return !v$.value.$invalid
  }
})
</script>

<template>
  <div v-if="umsokn">
    <v-col>
      <v-row>
        <v-col>
          <h2 class="form__header">
            {{ t('lan_vedflutning_step6_header') }}
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-textarea
            v-model="umsokn.comment"
            :placeholder="t('lan_vedflutning_step6_athugasemd')"
            :readonly="props.disable"
            name="lan_vedflutning_step6_athugasemd"
            variant="outlined"
            auto-grow
          />
        </v-col>
      </v-row>
    </v-col>
  </div>
</template>
